const previousAndNextArea = document.querySelector('#previous_and_next_area');
const loader = document.querySelector('.loader');
const script = document.querySelector('script#previous_and_next_post[type="module"]');
const csrfTokenMeta = document.querySelector('meta[name="csrf-token"]');

const elementExist = () => {
  if (!previousAndNextArea || !loader || !script || !csrfTokenMeta) {
    console.error('use_previous_and_next_post.js: ページに必要な要素が見つかりませんでした。');
    if (previousAndNextArea) {
      previousAndNextArea.innerHTML = '';
    }
    return false;
  }
  return true;
};

function main() {
  if (!elementExist()) return;

  // ローディング表示
  previousAndNextArea.innerHTML = `<div class="text-center">${loader.innerHTML}</div>`;

  const { url } = script.dataset;

  fetch(url, {
    method: 'GET',
    headers: {
      'X-CSRF-Token': csrfTokenMeta.content,
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
  .then((response) => {
    if (!response.ok) {
      throw new Error(`Network response was not ok, status: ${response.status}`);
    }
    return response.json();
  })
  .then((data) => {
    // レスポンスのHTMLをDOMに挿入
    previousAndNextArea.innerHTML = data.html;
  })
  .catch((error) => {
    console.error('There was a problem with the fetch operation:', error);
    // エラー発生時はエリアを空にする
    previousAndNextArea.innerHTML = '';
  });
}

main();
